/*!
 * Copyright © 2018-2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IVehicleDriverPanelState } from '../state';
import { EVehicleDriverPanelTabs, Position, IMapContextMenuData, MarkerInfo, IScrollItem } from '../../models';
import { isElementNull } from '../../../../utils';

export const getVehicleDriverPanelState = createFeatureSelector<IVehicleDriverPanelState>('vehicleDriverPanel');

export const getVehicleDriverPanel = createSelector(getVehicleDriverPanelState, state => state);

export const getIsVehicleDriverPanelCollapsed = createSelector(
  getVehicleDriverPanel,
  (state: IVehicleDriverPanelState): boolean => state.isCollapsed
);

export const getVehicleDriverPanelActiveTab = createSelector(
  getVehicleDriverPanel,
  (state: IVehicleDriverPanelState): EVehicleDriverPanelTabs => state.activeTab
);

export const getVehicleDriverOverlayMargins = createSelector(
  getVehicleDriverPanel,
  (state: IVehicleDriverPanelState): Position => (!isElementNull(state) ? state.overlayMargins : null)
);

export const getContextMenu = createSelector(
  getVehicleDriverPanel,
  (state: IVehicleDriverPanelState): IMapContextMenuData<MarkerInfo> => (!isElementNull(state) ? state.contextMenu : null)
);

export const getItemToScrollTo = createSelector(
  getVehicleDriverPanel,
  (state: IVehicleDriverPanelState): IScrollItem => state.itemToScrollTo
);
